import { FunctionComponent, useContext, useState } from "react";
import ImageSideContainer from "../../../components/ImageSideContainer";
import { UserContext } from "../../../context/UserContext";
import { AuthService } from "../../../services/auth";
import { useNavigate } from "react-router-dom";
import Label from "../../../components/Label";

const ConfirmAccount: FunctionComponent = ({}) => {
  const [forwardedMail, setForwardedMail] = useState<boolean>(false);

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const handleOnClick = () => {
    setForwardedMail(true);
    AuthService.resendLink(user.email);
    setTimeout(() => {
      setForwardedMail(false);
    }, 30000);
  };

  return (
    <>
      <ImageSideContainer>
        <section className="confirm">
          <header className="confirm__header">
            <Label tag="h1">Gracias por registrarte</Label>
            <Label tag="h3" style={{ margin: "1rem 0" }}>
              Falta solo 1 paso más!
            </Label>
          </header>
          <div className="confirm__body">
            <Label
              tag="p"
              variants="body1"
              className="confirm__spaced-paragraph"
            >
              Te hemos enviado un correo electrónico con un enlace para que
              valides tu dirección de correo electrónico y puedas acceder a
              nuestros productos.
            </Label>
            <Label
              tag="p"
              variants="body1"
              className="confirm__spaced-paragraph"
            >
              Por favor, sigue los siguientes pasos para activar tu cuenta:
            </Label>
            <Label tag="p" variants="body1" className="confirm__paragraph">
              1. Abre tu correo electrónico y busca el mensaje de nuestra
              plataforma web.
            </Label>
            <Label tag="p" variants="body1" className="confirm__paragraph">
              2. Haz click en el enlace de activación dentro del correo
              electrónico.
            </Label>
            <Label tag="p" variants="body1" className="confirm__paragraph">
              3. Serás redirigido a nuestra plataforma web donde podrás iniciar
              sesión y comenzar a utilizar nuestros servicios.
            </Label>
            <div className="confirm__validated-account">
              <button
                className="confirm_redirect_button"
                onClick={() => navigate("/login")}
              >
                Iniciar Sesión
              </button>
              {!forwardedMail ? (
                <>
                  <Label
                    tag="p"
                    variants="body2"
                    className="confirm__validated-account-paragraph"
                  >
                    ¿Aún no te llegó el código de confirmación?
                  </Label>

                  <p
                    className="confirm__validated-account-button"
                    onClick={handleOnClick}
                  >
                    Reenviar email
                  </p>
                </>
              ) : (
                <p className="confirm__validated-account-forwaded-mail">
                  Listo! ya hemos reenviado el email.
                </p>
              )}
            </div>
          </div>
        </section>
      </ImageSideContainer>
    </>
  );
};

export default ConfirmAccount;
